import formatAmount from "../../../../utils/FormetAmount";

const PNLCard = ({ title, value, color, icon }) => {
    return (
        <div className='flex items-center gap-3'>
            <div className={`flex justify-center items-center ${color} w-[45px] h-[45px] rounded-lg`}>
                {icon}
            </div>
            <div>
                <p className='sm:text-xl text-md'>$ {formatAmount(value || 0)}</p>
                <p className='text-sm font-medium text-gray-500 capitalize'>{title}</p>
            </div>
        </div>
    )
}

export default PNLCard
